import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function NotFound() {
  return (
    <div className="NotFound">
      <Typography variant="subtitle1">Sorry, page not found!</Typography>
    </div>
  );
}
